import { ReactComponent as DropdownSvg } from "../asserts/logo/dropdown.svg";

/** Local dropdown arrow for MUI Select (`IconComponent`). */
export default function SelectDropdownIcon({ className, style, ...props }) {
  return (
    <DropdownSvg
      className={className}
      aria-hidden
      focusable="false"
      {...props}
      style={{ width: 24, height: 24, display: "block", flexShrink: 0, ...style }}
    />
  );
}
